<template>
  <div>
    <v-select
      class="small-text-field"
      :required="required"
      :value="rideType"
      :label="label"
      :items="rideTypesFiltered"
      :v-model="rideType"
      item-value="id"
      item-name="name"
      @input="updateSelf"
      :height="28"
      flat
      :hide-details="valid() == true && (error == null || error.length == 0)"
      :error-messages="valid() == true ? null : [valid()] "
      outlined
      dense
      style="width: 90px;"
    >
      <template v-slot:append-outer>
        <v-icon small @click="showLuggageInfoDialog = true">mdi-information</v-icon>
      </template>
      <template v-slot:selection="{ item, index }">
      <span
        style="font-size: 12px !important"
        v-html="item.name.substring(0, 10).replace(' ', '&nbsp;')"
      ></span>
      </template>
      <template v-slot:item="{ item, index }">
      <span
        style="font-size: 12px !important"
        v-html="'<b>' + item.name.replace(' ', '&nbsp;') + '</b> &nbsp;' +
       item.description.replace(' ', '&nbsp;')"
      ></span>
      </template>
    </v-select>
    <v-dialog
      v-model="showLuggageInfoDialog"
      width="1000"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Luggage Information
        </v-card-title>
        <v-card-text>
          <LuggageInfoBox></LuggageInfoBox>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="showLuggageInfoDialog = false"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LuggageInfoBox from '@/components/luggage/LuggageInfoBox'
export default {
  name: "SelectableRideTypeInput",
  components: {LuggageInfoBox},
  model: {
    prop: "rideType",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    rideType: Number,
    rideTypes: Array,
    error: String,
    bookingForm: Object
  },
  computed: {
    rideTypesFiltered: function() {

      var self = this;

      if (!self.bookingForm.costs) {
        return;
      }

      return self.rideTypes.filter(function(f) {

        if (f.enabled == false) {
          return false;
        }


        for (var i = 0; i < self.bookingForm.costs.length; i++) {
          if (self.bookingForm.costs[i].id == f.id) {
            return true;
          }
        }

        return false;
      });
    }
  },
  data() {
    return {
      showLuggageInfoDialog: false,
      menu: false
    };
  },
  methods: {
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(rideType) {
      this.$emit("input", rideType);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
